import React from 'react';

const SingleBanners = ({text,color}) => {
    return (
        <a href="#" className={["single-banners " + color]}>
            <div
                className="banner d-flex justify-content-between flex-column flex-sm-row align-items-center xpy-8 xpx-4 xpx-lg-10">
                <div className="text"><span>{text}</span></div>
                <span className="button">بررسی و خرید</span>
            </div>
        </a>
    );
};

export default SingleBanners;
